const version = '1.0.0-5d751150'; export default version;
